<template>
  <main class="login login-screen">
    <v-container fill-height class="login-container">
      <img
        :src="require('../../assets/_2/ic_logo_jns_menu.png')"
        class="login-logo"
        alt
      />
      <v-layout row wrap>
        <v-flex xs12 v-if="!mostraMensagemBloqueio">
          <form-alert
            :type="alertText.type"
            :message="alertText.message"
            @close="closeFormAlert"
          ></form-alert>
        </v-flex>
        <v-flex class="text-xs-center no-padding" offset-xs2 xs8>
          <div class="main-title">
            <p class="yellow--text mb-0 line-1">Seja bem-vindo ao</p>
            <p class="white--text font-weight-black text-uppercase line-2">
              Portal do Tomador
            </p>
          </div>
          <v-form class="login-form" @click.prevent>
            <div class="login-error" v-if="formErrors && formErrors.error">
              <div class="input-group__error">
                <v-icon>warning</v-icon>
                {{ formErrors.error }}
              </div>
            </div>
            <v-flex xs12>
              <v-text-field
                v-model="model.username"
                :label="'E-mail'"
                placeholder=" "
                hide-details
                height="45"
                class="login-input mb-4 input-email"
              ></v-text-field>
            </v-flex>

            <v-flex xs12>
              <v-text-field
                v-model="model.password"
                label="Senha"
                placeholder=" "
                height="45"
                type="password"
                class="login-input"
                hide-details
              ></v-text-field>
            </v-flex>

            <v-flex xs12>
              <button
                @click.prevent="getCompanies(model)"
                class="
                  btn-primary
                  jns-button
                  mt-4
                  jns-button-login
                  font-weight-black
                "
              >
                Entrar
              </button>
            </v-flex>
          </v-form>
        </v-flex>
      </v-layout>
      <v-dialog v-model="selectCompanyDialog" :max-width="'640'">
        <selecionar-empresa-modal
          @close="
            selectCompanyDialog = false;
            $forceUpdate();
          "
          @click="selectCompanyToLogin"
          persistent
          :companies="companies"
        ></selecionar-empresa-modal>
      </v-dialog>
      <versao-label />
    </v-container>
  </main>
</template>

<script lang="js">
import axios from "axios";
import ViewMixin from "@/mixins/ViewMixin";

export default {
  name: "Home",
  mixins: [ViewMixin],
  data: () => ({
    formErrors: [],
    model: {
      username: null,
      password: null,
      me: undefined,
    },
    selectCompanyDialog: false,
    blockUserDialog: false,
    blockUserHash: false,
    companies: false,
    companyUsers: false,
    debugMode: false,
    imgNovidade: "require('../../assets/novas_demandas.png')",
  }),
  methods: {
    personalInfo(data) {
      this.$store
        .dispatch("ME_INFO", data)
        .then((response) => {
          // this.$store.main.commit('ME',payload).then(response => {
          localStorage.setItem("me", JSON.stringify(response));
          this.$router.push({ name: "Consultorias" });
        })
        .catch(this.errorHandler);
    },
    auth(data) {
      this.showLoadingIndicator();
      this.$store
        .dispatch("LOGIN", data)
        .then(this.authHandler)
        .catch(this.selectCompanyErrorHandler);
    },
    async getCompanies(data) {
      if (!this.model.username || !this.model.password) return;

      this.model.username = this.model.username.toLowerCase();
      this.showLoadingIndicator();
      await this.$store
        .dispatch("GET_COMPANIES", data)
        .then(this.companiesHandler)
        .catch(this.companiesHandlerError);
    },

    companiesHandler(response) {
      if (response.length == 1) {
        this.auth({
          username: this.model.username,
          password: this.model.password,
          company_id: response[0].id,
        });
      } else {
        this.companies = response;
        this.$nextTick(() => {
          this.selectCompanyDialog = true;
        });
      }
      this.hideLoadingIndicator();
    },

    companiesHandlerError(e) {
      var error = {};
      if (e && e.response && e.response.data)
        error = {
          type: "error",
          message: e.response.data.message,
        };
      else error = this.$strings.invalidUserOrPassword;

      this.$store.commit("SET_ALERT_TEXT", error);
      this.alertText = this.handleAlertText();
      this.$forceUpdate();
      this.hideLoadingIndicator();
      return;
    },

    selectCompanyToLogin(company) {
      this.auth({
        username: this.model.username,
        password: this.model.password,
        company_id: company.id,
      });
    },
    fakePopulateCompanies(companies) {
      let company = companies[0];
      for (let i = 0; i <= 4; i++) {
        companies.push(company);
      }
      return companies;
    },
    async authHandler(response) {
      this.hideLoadingIndicator();
      localStorage.setItem("auth_token", response.access_token);
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("auth_token");
      try {
        this.me = await this.$store.dispatch("GET_ME");
        // if (!this.$cookie.get(this.me.name)) this.handleNovidade();
      } catch (e) {
        console.warn(e);
      }
      if (!this.me) {
        console.warn("erro");
        return;
      }

      localStorage.setItem("me", JSON.stringify(this.me));
      if (!this.me.tos_accepted) {
        this.$router.push({ name: "Termos de Serviço" });
      } else {
        this.$router.push({ name: "Portal do Tomador" });
      }
    },

    errorHandler(error) {
      this.hideLoadingIndicator();
      console.warn(error);
      let errorMessage = this.$strings.invalidUserOrPassword;
      if (error.status == 401) {
        errorMessage.message =
          "Usuário bloqueado, entre em contato com o administrador";
      }
      this.alertText = this.handleAlertText2(errorMessage);
      this.$forceUpdate();
      return;
    },
    selectCompanyErrorHandler(error) {
      this.hideLoadingIndicator();

      let message =
        "Não é possível autenticar com a corretora selecionada no momento. Entre em contato com o SAC para maiores informações.";
      let options = {};
      if (error.data) {
        options = error.data;
      } else if (error.response) {
        options = error.response.data;
      }
      if (options !== undefined && options !== {} && options !== null) {
        message = options.message;
      }

      this.alertText = this.handleAlertText2(message, "error");
      this.selectCompanyDialog = false;
      this.$forceUpdate();
      return false;
    },
    isBlockUsersPage() {
      return this.$route.name == "Bloquear Usuários" && this.$route.params.hash;
    },
    checkBlockUsersHash(hash) {
      this.showLoadingIndicator();
      this.$store
        .dispatch("LIST_USERS_COMPANY", { hash })
        .then((response) => {
          this.hideLoadingIndicator();
          this.companyUsers = response;
          this.blockUserHash = hash;
          this.blockUserDialog = true;
        })
        .catch(this.errorHandler);
    },
  },
  mounted() {
    if (this.$route.query.expiredSession) {
      // Ex: http://localhost:8080/#/login?expiredSession=true
      this.alertText = this.handleAlertText2(
        "Sessão expirada, entre com suas credenciais para acessar novamente.",
        "error"
      );
    } else {
      this.alertText = this.handleAlertText();
    }

    if (this.isBlockUsersPage()) {
      this.checkBlockUsersHash(this.$route.params.hash);
    }
    if (
      this.$route.params.debugFlag &&
      this.$route.params.debugFlag == "debug"
    ) {
      this.debugMode = true;
    }
  },
};
</script>

<style lang="scss" scoped>
#jns {
  .login {
    &-error {
      color: red;
      font-weight: bold;
      margin-top: 1rem;
      i {
        color: red;
      }
    }
    &-logo {
      position: absolute;
      top: 54px;
      left: 64px;
    }
  }

  .jns-button-login {
    font-weight: bold;
    border-radius: 45px;
    width: calc(100% + 26px);
    margin-left: -13px;
  }
  .register-button {
    border-radius: 45px;
    width: calc(100% + 26px);
    margin-left: -13px;
  }
  .recover-password-link {
    margin-top: 20px;
  }
  hr {
    margin-top: 20px;
    border: none;

    border-top: 1px solid rgba(25, 23, 55, 0.1);
  }
  .line {
    &-1 {
      font-size: 25px;
      font-weight: 500;
      letter-spacing: 1px;
      line-height: 48px;
      text-align: center;
      text-shadow: 0 3px 15px 0 rgba(0, 0, 0, 0.37);
    }
    &-2 {
      font-size: 36px;
      font-weight: 900;
      letter-spacing: 1px;
      margin-bottom: 30px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/router/views/Login.vue